export const pages = {
	langFile: "menuMain",
};
